// @flow
import React from 'react';
import { useSelector } from 'react-redux';
import { sessionConfigSelector } from '../../selectors/configSelectors';
import { getActivityIndex } from '../../utils/targetUtils';
import useNow from '../../hooks/useNow';
import Dot from './Dot';

const COLORS = ['gray', 'red', 'yellow', 'green'];

export type Props = $ReadOnly<{
    dateString?: string
}>;

function Status({ dateString }: Props) {
    useNow();
    const sessionConfig = useSelector(sessionConfigSelector);
    const color = COLORS[getActivityIndex(dateString, sessionConfig)] || 'gray';

    return (
        <Dot color={color} />
    );
}

export default Status;